import { ref, computed } from 'vue';
import VariationsField from '../shared/Fields/VariationsField.vue';
import { schema } from './schema';
import { initialValues } from './initialValues';
import ImportantInformationField from '../shared/Fields/ImportantInformationField.vue';
import UploadedFileField from '../shared/Fields/UploadedFileField.vue';
import PatientData from '../shared/PatientData.vue';
import ProductForm from '../shared/ProductForm.vue';
import Terms from '../shared/Terms.vue';
import Sex from '../shared/Fields/Marihuana/Sex.vue';
import IsSubstanceDependentOrUsing from '../shared/Fields/Marihuana/isSubstanceDependentOrUsing.vue';
import IsAlergicToMedication from '../shared/Fields/Marihuana/IsAlergicToMedication.vue';
import IsTakingCurrentlyMedications from '../shared/Fields/Marihuana/IsTakingCurrentlyMedications.vue';
import HasChronicOrComorbidConditions from '../shared/Fields/Marihuana/hasChronicOrComorbidConditions.vue';
import MarihuanaSelect from '../shared/Fields/Marihuana/MarihuanaSelect.vue';


export default {
  __name: 'Marihuana',
  props: {
    checkoutlink: { type: String, required: true },
    price: {
        type: String,
        required: true,
    },
    id: {
        type: Number,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
    shortdescription: {
        type: String,
        required: true,
    },
    customer: {
        type: String,
        required: false,
    },
    variations: {
        type: String,
        required: false,
    },
    variantname: {
        type: String,
        required: false,
    },
},
  setup(__props, { expose }) {
  expose();

const props = __props;



const customerData = JSON.parse(props.customer || '{}');

const variationsData = JSON.parse(props.variations || []);
const selectedVariation = ref(variationsData[variationsData.length - 1]?.variation_id);

const selectVariation = (variationId) => {
    selectedVariation.value = variationId;
};

const values = computed(() => initialValues(customerData));

const __returned__ = { props, customerData, variationsData, selectedVariation, selectVariation, values, ref, computed, VariationsField, get schema() { return schema }, get initialValues() { return initialValues }, ImportantInformationField, UploadedFileField, PatientData, ProductForm, Terms, Sex, IsSubstanceDependentOrUsing, IsAlergicToMedication, IsTakingCurrentlyMedications, HasChronicOrComorbidConditions, MarihuanaSelect }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}